import React, { useEffect, useMemo, useState } from "react";

import { ImageIcon } from "../Svg";
import { isVideo } from "../utils";
import { RawVideo, VerticalVideo } from "@talentbait/remotion-templates-talentbait";
import GlobalVideoGeneratorPreview from "../VideoGenerator/GlobalVideoGeneratorPreview/GlobalVideoGeneratorPreview";
import { EmptyImageWrapper } from "../campaign-create-photo-editor/CampaignCreatePhotoEditor.styled";
import { getVideoDuration } from "../TemplatePost/TemplatePost__Preview/utils";
import Actions from "../../../../Actions";
import { getGifDurationInSeconds } from "@remotion/gif";
import { VIDEO_FPS } from "../VideoGenerator/VideoGenerator__Preview/VideoGenerator__Preview.constants";

const VideoEditorCreative = ({ url, width, height, videoData, updatePost }) => {
  const [duration, setDuration] = useState(300); // 20 seconds x 15 fps = 300
  const isImageURL = useMemo(() => !isVideo(url), [url]);
  const isGif = url?.toLowerCase()?.endsWith(".gif");

  const inputProps = useMemo(() => {
    if (!url) return null;

    return {
      video: isImageURL ? null : url,
      backgroundImage: isImageURL ? url : null,
      audioUrl: videoData?.audioUrl || "",
      templateId: isImageURL ? "VerticalVideo" : "RawVideo",
      duration: isImageURL ? 20 : null,
      isGenerated: false,
      ...(isImageURL && { text: "" })
    };
  }, [url, videoData?.audioUrl, isImageURL]);

  useEffect(() => {
    if (url && !isImageURL) {
      const fetchDuration = async () => {
        const videoDuration = await getVideoDuration(url);
        setDuration(Math.round(videoDuration * VIDEO_FPS));
      };
      fetchDuration();
    }
    if (url && isGif) {
      const fetchDuration = async () => {
        const gifDuration = await getGifDurationInSeconds(url);
        setDuration(Math.round(gifDuration * VIDEO_FPS));
      };
      fetchDuration();
    }
  }, [url, isImageURL, isGif]);

  useEffect(() => {
    Actions.updateTemplateDataToDownload({
      inputProps,
      templateId: isImageURL ? "VerticalVideo" : "RawVideo"
    });
    if (JSON.stringify(videoData) !== JSON.stringify(inputProps)) {
      updatePost({ videoData: { ...videoData, ...inputProps } });
    }
  }, [isImageURL]);

  if (!url) {
    return (
      <EmptyImageWrapper data-testid="test_EmptyImageWrapper_Creative_Empty">
        <ImageIcon />
      </EmptyImageWrapper>
    );
  }

  return (
    <GlobalVideoGeneratorPreview
      remotionTemplate={isImageURL ? VerticalVideo : RawVideo}
      width={width || 1080}
      height={height || 1920}
      duration={duration}
      videoData={inputProps}
      fullWidth
    />
  );
};

export default VideoEditorCreative;
